const canvaSDKScriptId: string = 'canvaSDK'

let apiInitialized: TCanvaButtonApi | null = null

export type TCanvaDesignTypeName =
  | 'A4Document'
  | 'Announcement'
  | 'BirthdayCard'
  | 'BirthdayInvitation'
  | 'BlogBanner'
  | 'BookCover'
  | 'Bookmark'
  | 'Brochure'
  | 'BusinessCard'
  | 'Calendar'
  | 'Card'
  | 'Certificate'
  | 'DesktopWallpaper'
  | 'EmailHeader'
  | 'EtsyShopCover'
  | 'EtsyShopIcon'
  | 'FacebookAd'
  | 'FacebookAppAd'
  | 'FacebookCover'
  | 'FacebookEventCover'
  | 'FacebookPost'
  | 'Flyer'
  | 'GiftCertificate'
  | 'Infographic'
  | 'InstagramPost'
  | 'InstagramStory'
  | 'Invitation'
  | 'Invoice'
  | 'Label'
  | 'LargeRectangleAd'
  | 'LeaderboardAd'
  | 'LessonPlan'
  | 'Letter'
  | 'LinkedInBanner'
  | 'Logo'
  | 'MagazineCover'
  | 'MediumRectangleAd'
  | 'Menu'
  | 'MindMap'
  | 'Newsletter'
  | 'PhotoCollage'
  | 'PinterestGraphic'
  | 'PodcastCover'
  | 'Postcard'
  | 'Poster'
  | 'Presentation'
  | 'Presentation43'
  | 'ProductLabel'
  | 'RecipeCard'
  | 'Resume'
  | 'SnapchatGeofilter'
  | 'SocialMedia'
  | 'Ticket'
  | 'TumblrGraphic'
  | 'TwitterHeader'
  | 'TwitterPost'
  | 'WattpadBookCover'
  | 'WeddingInvitation'
  | 'WideSkyscraperAd'
  | 'Worksheet'
  | 'Yearbook'
  | 'YouTubeChannelArt'
  | 'YouTubeThumbnail'

export enum MEASURE_TYPE {
  TYPE_CM = 'cm',
  TYPE_IN = 'in',
  TYPE_PX = 'px',
  TYPE_MM = 'mm'
}

export enum DESIGN_TYPE {
  CANVA_TYPE = 'canva',
  CUSTOM_TYPE = 'custom'
}

export type TCanvaDesignType = {
  type: DESIGN_TYPE
  name: TCanvaDesignTypeName
  width: number
  height: number
  measure: MEASURE_TYPE
}

export type TCustomCanvaDesignType = {
  type: DESIGN_TYPE
  name: string
  width: number
  height: number
  measure: MEASURE_TYPE
}

type TCanvaDesignTypeMap = {
  [key in TCanvaDesignTypeName]: TCanvaDesignType
}

export const CANVA_DESIGN_TYPE: TCanvaDesignTypeMap = {
  A4Document: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'A4Document',
    width: 21,
    height: 27,
    measure: MEASURE_TYPE.TYPE_CM
  },
  Announcement: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Announcement',
    width: 5,
    height: 7,
    measure: MEASURE_TYPE.TYPE_IN
  },
  BirthdayCard: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'BirthdayCard',
    width: 7,
    height: 5,
    measure: MEASURE_TYPE.TYPE_IN
  },
  BirthdayInvitation: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'BirthdayInvitation',
    width: 14,
    height: 14,
    measure: MEASURE_TYPE.TYPE_CM
  },
  BlogBanner: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'BlogBanner',
    width: 560,
    height: 315,
    measure: MEASURE_TYPE.TYPE_PX
  },
  BookCover: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'BookCover',
    width: 1410,
    height: 2250,
    measure: MEASURE_TYPE.TYPE_PX
  },
  Bookmark: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Bookmark',
    width: 2,
    height: 6,
    measure: MEASURE_TYPE.TYPE_IN
  },
  Brochure: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Brochure',
    width: 11,
    height: 8.5,
    measure: MEASURE_TYPE.TYPE_IN
  },
  BusinessCard: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'BusinessCard',
    width: 8.5,
    height: 5,
    measure: MEASURE_TYPE.TYPE_CM
  },
  Calendar: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Calendar',
    width: 1920,
    height: 1080,
    measure: MEASURE_TYPE.TYPE_PX
  },
  Card: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Card',
    width: 7,
    height: 5,
    measure: MEASURE_TYPE.TYPE_IN
  },
  Certificate: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Certificate',
    width: 29.7,
    height: 21,
    measure: MEASURE_TYPE.TYPE_CM
  },
  DesktopWallpaper: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'DesktopWallpaper',
    width: 1920,
    height: 1080,
    measure: MEASURE_TYPE.TYPE_PX
  },
  EmailHeader: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'EmailHeader',
    width: 600,
    height: 200,
    measure: MEASURE_TYPE.TYPE_PX
  },
  EtsyShopCover: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'EtsyShopCover',
    width: 1200,
    height: 300,
    measure: MEASURE_TYPE.TYPE_PX
  },
  EtsyShopIcon: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'EtsyShopIcon',
    width: 500,
    height: 500,
    measure: MEASURE_TYPE.TYPE_PX
  },
  FacebookAd: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'FacebookAd',
    width: 1200,
    height: 628,
    measure: MEASURE_TYPE.TYPE_PX
  },
  FacebookAppAd: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'FacebookAppAd',
    width: 810,
    height: 450,
    measure: MEASURE_TYPE.TYPE_PX
  },
  FacebookCover: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'FacebookCover',
    width: 1080,
    height: 1920,
    measure: MEASURE_TYPE.TYPE_PX
  },
  FacebookEventCover: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'FacebookEventCover',
    width: 1920,
    height: 1080,
    measure: MEASURE_TYPE.TYPE_PX
  },
  FacebookPost: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'FacebookPost',
    width: 940,
    height: 788,
    measure: MEASURE_TYPE.TYPE_PX
  },
  Flyer: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Flyer',
    width: 21,
    height: 29.7,
    measure: MEASURE_TYPE.TYPE_CM
  },
  GiftCertificate: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'GiftCertificate',
    width: 6,
    height: 4,
    measure: MEASURE_TYPE.TYPE_IN
  },
  Infographic: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Infographic',
    width: 800,
    height: 2000,
    measure: MEASURE_TYPE.TYPE_PX
  },
  InstagramPost: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'InstagramPost',
    width: 1080,
    height: 1080,
    measure: MEASURE_TYPE.TYPE_PX
  },
  InstagramStory: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'InstagramStory',
    width: 1080,
    height: 1920,
    measure: MEASURE_TYPE.TYPE_PX
  },
  Invitation: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Invitation',
    width: 14,
    height: 14,
    measure: MEASURE_TYPE.TYPE_CM
  },
  Invoice: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Invoice',
    width: 21,
    height: 29.7,
    measure: MEASURE_TYPE.TYPE_CM
  },
  Label: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Label',
    width: 6,
    height: 4,
    measure: MEASURE_TYPE.TYPE_IN
  },
  LargeRectangleAd: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'LargeRectangleAd',
    width: 330,
    height: 280,
    measure: MEASURE_TYPE.TYPE_PX
  },
  LeaderboardAd: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'LeaderboardAd',
    width: 728,
    height: 90,
    measure: MEASURE_TYPE.TYPE_PX
  },
  LessonPlan: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'LessonPlan',
    width: 21,
    height: 29.7,
    measure: MEASURE_TYPE.TYPE_CM
  },
  Letter: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Letter',
    width: 21,
    height: 29.7,
    measure: MEASURE_TYPE.TYPE_CM
  },
  LinkedInBanner: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'LinkedInBanner',
    width: 1400,
    height: 425,
    measure: MEASURE_TYPE.TYPE_PX
  },
  Logo: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Logo',
    width: 500,
    height: 500,
    measure: MEASURE_TYPE.TYPE_PX
  },
  MagazineCover: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'MagazineCover',
    width: 21,
    height: 29.7,
    measure: MEASURE_TYPE.TYPE_CM
  },
  MediumRectangleAd: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'MediumRectangleAd',
    width: 300,
    height: 250,
    measure: MEASURE_TYPE.TYPE_PX
  },
  Menu: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Menu',
    width: 21,
    height: 29.7,
    measure: MEASURE_TYPE.TYPE_CM
  },
  MindMap: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'MindMap',
    width: 1024,
    height: 768,
    measure: MEASURE_TYPE.TYPE_PX
  },
  Newsletter: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Newsletter',
    width: 21,
    height: 29.7,
    measure: MEASURE_TYPE.TYPE_CM
  },
  PhotoCollage: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'PhotoCollage',
    width: 25,
    height: 20,
    measure: MEASURE_TYPE.TYPE_CM
  },
  PinterestGraphic: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'PinterestGraphic',
    width: 735,
    height: 1102,
    measure: MEASURE_TYPE.TYPE_PX
  },
  PodcastCover: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'PodcastCover',
    width: 3000,
    height: 3000,
    measure: MEASURE_TYPE.TYPE_PX
  },
  Postcard: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Postcard',
    width: 14.8,
    height: 10.5,
    measure: MEASURE_TYPE.TYPE_CM
  },
  Poster: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Poster',
    width: 42,
    height: 59.4,
    measure: MEASURE_TYPE.TYPE_CM
  },
  Presentation: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Presentation',
    width: 1920,
    height: 1080,
    measure: MEASURE_TYPE.TYPE_PX
  },
  Presentation43: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Presentation43',
    width: 1024,
    height: 768,
    measure: MEASURE_TYPE.TYPE_PX
  },
  ProductLabel: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'ProductLabel',
    width: 6,
    height: 4,
    measure: MEASURE_TYPE.TYPE_IN
  },
  RecipeCard: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'RecipeCard',
    width: 800,
    height: 1200,
    measure: MEASURE_TYPE.TYPE_PX
  },
  Resume: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Resume',
    width: 21,
    height: 29.7,
    measure: MEASURE_TYPE.TYPE_CM
  },
  SnapchatGeofilter: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'SnapchatGeofilter',
    width: 1080,
    height: 2340,
    measure: MEASURE_TYPE.TYPE_PX
  },
  SocialMedia: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'SocialMedia',
    width: 800,
    height: 800,
    measure: MEASURE_TYPE.TYPE_PX
  },
  Ticket: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Ticket',
    width: 8.5,
    height: 2.8,
    measure: MEASURE_TYPE.TYPE_IN
  },
  TumblrGraphic: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'TumblrGraphic',
    width: 540,
    height: 810,
    measure: MEASURE_TYPE.TYPE_PX
  },
  TwitterHeader: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'TwitterHeader',
    width: 1500,
    height: 500,
    measure: MEASURE_TYPE.TYPE_PX
  },
  TwitterPost: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'TwitterPost',
    width: 1042,
    height: 512,
    measure: MEASURE_TYPE.TYPE_PX
  },
  WattpadBookCover: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'WattpadBookCover',
    width: 512,
    height: 800,
    measure: MEASURE_TYPE.TYPE_PX
  },
  WeddingInvitation: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'WeddingInvitation',
    width: 5,
    height: 7,
    measure: MEASURE_TYPE.TYPE_IN
  },
  WideSkyscraperAd: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'WideSkyscraperAd',
    width: 160,
    height: 600,
    measure: MEASURE_TYPE.TYPE_PX
  },
  Worksheet: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Worksheet',
    width: 21,
    height: 29.7,
    measure: MEASURE_TYPE.TYPE_CM
  },
  Yearbook: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'Yearbook',
    width: 21,
    height: 29.7,
    measure: MEASURE_TYPE.TYPE_CM
  },
  YouTubeChannelArt: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'YouTubeChannelArt',
    width: 2560,
    height: 1440,
    measure: MEASURE_TYPE.TYPE_PX
  },
  YouTubeThumbnail: {
    type: DESIGN_TYPE.CANVA_TYPE,
    name: 'YouTubeThumbnail',
    width: 1280,
    height: 720,
    measure: MEASURE_TYPE.TYPE_PX
  }
}

export const DESIGN_TYPE_FROM_RESTRICTION_FOR_CANVA: { [key in string]: TCustomCanvaDesignType } = {
  FacebookDefaultMinSize: {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Facebook Default Min Size',
    width: 600,
    height: 315,
    measure: MEASURE_TYPE.TYPE_PX
  },
  'FacebookSinglePhoto1.91:1': {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Facebook Single Photo 1.91:1',
    width: 1200,
    height: 628,
    measure: MEASURE_TYPE.TYPE_PX
  },
  'FacebookSinglePhoto2:3': {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Facebook Single Photo 2:3',
    width: 1200,
    height: 1800,
    measure: MEASURE_TYPE.TYPE_PX
  },
  'FacebookSinglePhoto1:1': {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Facebook Single Photo 1:1',
    width: 1200,
    height: 1200,
    measure: MEASURE_TYPE.TYPE_PX
  },
  'FacebookMultiPhoto1.91:1': {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Facebook Multi Photo 1.91:1',
    width: 1200,
    height: 628,
    measure: MEASURE_TYPE.TYPE_PX
  },
  'FacebookMultiPhoto2:3': {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Facebook Multi Photo 2:3',
    width: 1200,
    height: 1800,
    measure: MEASURE_TYPE.TYPE_PX
  },
  'FacebookMultiPhoto1:1': {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Facebook Multi Photo 1:1',
    width: 1200,
    height: 1200,
    measure: MEASURE_TYPE.TYPE_PX
  },
  'FacebookPhotoStory9:16': {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Facebook Photo Story 9:16',
    width: 1080,
    height: 1920,
    measure: MEASURE_TYPE.TYPE_PX
  },
  InstagramDefaultMaxSize: {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Instagram Default Max Size',
    width: 1080,
    height: 1080,
    measure: MEASURE_TYPE.TYPE_PX
  },
  InstagramDefaultMinSize: {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Instagram Default Min Size',
    width: 320,
    height: 320,
    measure: MEASURE_TYPE.TYPE_PX
  },
  'InstagramSinglePhoto1:1': {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Instagram Single Photo 1:1',
    width: 1080,
    height: 1080,
    measure: MEASURE_TYPE.TYPE_PX
  },
  'InstagramSinglePhoto1.91:1': {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Instagram Single Photo 1.91:1',
    width: 1080,
    height: 608,
    measure: MEASURE_TYPE.TYPE_PX
  },
  'InstagramSinglePhoto4:5': {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Instagram Single Photo 4:5',
    width: 1080,
    height: 1350,
    measure: MEASURE_TYPE.TYPE_PX
  },
  'InstagramMultiPhoto1:1': {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Instagram Multi Photo 1:1',
    width: 1080,
    height: 1080,
    measure: MEASURE_TYPE.TYPE_PX
  },
  'InstagramMultiPhoto1.91:1': {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Instagram Multi Photo 1.91:1',
    width: 1080,
    height: 608,
    measure: MEASURE_TYPE.TYPE_PX
  },
  'InstagramMultiPhoto4:5': {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Instagram Multi Photo 4:5',
    width: 1080,
    height: 1350,
    measure: MEASURE_TYPE.TYPE_PX
  },
  'InstagramPhotoStory9:16': {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Instagram Photo Story 9:16',
    width: 1080,
    height: 1920,
    measure: MEASURE_TYPE.TYPE_PX
  },
  'LinkedinDefault1.91:1': {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Linkedin Default 1.91:1',
    width: 1200,
    height: 628,
    measure: MEASURE_TYPE.TYPE_PX
  },
  'TwitterDefault16:9': {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Twitter Default 16:9',
    width: 1200,
    height: 675,
    measure: MEASURE_TYPE.TYPE_PX
  },
  'TwitterDefault2:1': {
    type: DESIGN_TYPE.CUSTOM_TYPE,
    name: 'Twitter Default 2:1',
    width: 1024,
    height: 512,
    measure: MEASURE_TYPE.TYPE_PX
  }
}

export type TCanvaButtonApi = {
  createDesign: (opts: {
    design: {
      type: TCanvaDesignTypeName
      dimensions?: {
        width: number
        height: number
        units?: 'px' | 'cm' | 'mm' | 'in'
      }
    }
    editor?: {
      publishLabel?: string
      fileType?: 'jpg' | 'jpeg' | 'pdf' | 'png'
    }
    onDesignOpen?: (opts: { designId: string }) => void
    onDesignPublish?: (opts: { exportUrl: string; designId: string }) => void
    onDesignClose?: () => void
  }) => void
  editDesign: (opts: {
    design: {
      id: string
    }
    editor?: {
      publishLabel?: string
      fileType?: 'jpg' | 'jpeg' | 'pdf' | 'png'
    }
    onDesignOpen?: (opts: { designId: string }) => void
    onDesignPublish?: (opts: { exportUrl: string; designId: string }) => void
    onDesignClose?: () => void
  }) => void
}

declare global {
  interface Window {
    Canva?: {
      DesignButton: {
        initialize: (opts: { apiKey: string }) => Promise<TCanvaButtonApi>
      }
    }
  }
}

export const loadCanvaSdk = () =>
  new Promise<void>((resolve) => {
    // load canva sdk script
    ;((document, url) => {
      const canvaSDKScriptLoaded = document.getElementById(canvaSDKScriptId)
      if (canvaSDKScriptLoaded) {
        resolve()
      } else {
        const canvaSDKScript = document.createElement('script')
        canvaSDKScript.id = canvaSDKScriptId
        canvaSDKScript.src = url
        canvaSDKScript.onload = function () {
          // API initialization
          resolve()
        }
        document.body.appendChild(canvaSDKScript)
      }
    })(document, 'https://sdk.canva.com/designbutton/v2/api.js')
  })

export const removeCanvaSDKScript = () => {
  const canvaSDKScript = document.getElementById(canvaSDKScriptId)
  canvaSDKScript?.remove()
  delete window.Canva
}

export const initCanvaAPI = async () => {
  if (!apiInitialized) {
    const api = await window.Canva!.DesignButton.initialize({
      apiKey: process.env.REACT_APP_CANVA_API_KEY!
    })
    apiInitialized = api
    return apiInitialized
  } else {
    return apiInitialized
  }
}
